const STORAGE_KEY = 'lccto-gmail-confirm-signature-v1';

/** Default plain-text sign-off when nothing is saved yet. */
export const DEFAULT_GMAIL_CONFIRM_SIGNATURE = `Stephan Smith
https://stephansmith.me`;

export function loadGmailConfirmSignature(): string {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw == null) return DEFAULT_GMAIL_CONFIRM_SIGNATURE;
    return raw;
  } catch {
    return DEFAULT_GMAIL_CONFIRM_SIGNATURE;
  }
}

export function saveGmailConfirmSignature(value: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // ignore quota / private mode
  }
}

/** Append saved signature to a confirm draft body (avoids double "— Stephan"). */
export function appendGmailConfirmSignature(body: string, signature: string): string {
  const base = body
    .replace(/\n*—\s*Stephan\s*$/i, '')
    .replace(/\n+Stephan\s*$/i, '')
    .replace(/\s+$/u, '');
  const sig = signature.replace(/^\s+|\s+$/gu, '');
  if (!sig) return `${base}\n\nStephan`;
  return `${base}\n\n${sig}`;
}
